/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * LinkIcon
 */
export default class LinkIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M21.1 2.7c-2.3-2.3-6-2.3-8.3 0l-1.7 1.7c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0l1.7-1.7c1.5-1.5 4-1.5 5.5 0 .8.7 1.2 1.7 1.2 2.8 0 1.1-.4 2.1-1.1 2.9l-3 3c-.1.1-.2.2-.2.3-.1 0-.1.1-.2.1-1.7 1.3-4.2 1-5.6-.8-.3-.4-1-.5-1.4-.2-.4.3-.5 1-.2 1.4 1.2 1.6 3 2.4 4.8 2.4 1.2 0 2.5-.4 3.5-1.2.3-.2.6-.4.8-.7l2.9-2.9c1.1-1.2 1.7-2.7 1.7-4.3 0-1.6-.7-3.1-1.8-4.2zm-9.6 15.5l-1.7 1.7c-1.5 1.5-4 1.5-5.5 0-.8-.7-1.2-1.7-1.2-2.8 0-1.1.4-2.1 1.1-2.9l3-3c.1-.1.2-.2.2-.3.1 0 .1-.1.2-.1.8-.6 1.9-.9 2.9-.8 1.1.2 2 .7 2.7 1.6.3.4 1 .5 1.4.2.4-.3.5-1 .2-1.4a5.9 5.9 0 00-4-2.3c-1.5-.3-3.1.1-4.3 1.1-.3.1-.6.4-.8.7l-2.9 2.9c-1.1 1.2-1.7 2.7-1.7 4.3 0 1.6.7 3.1 1.8 4.2S5.5 23 7 23c1.6 0 3-.6 4.2-1.7l1.7-1.7c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0z"/><g fillRule="evenodd"><use/><use fillRule="nonzero"/></g></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

